export default __webpack_public_path__ + "static/media/Scuba.03f9e405.svg";